import type { CalcKey } from '../locales/keys';

export interface TangentPreset {
  id: string;
  labelKey: CalcKey;
  source: string;
  a: number;
  domain: [number, number];
}

export const TANGENT_PRESETS: TangentPreset[] = [
  {
    id: 'parabola',
    labelKey: 'preset.tangent.parabola',
    // f(x) = x², f′(x) = 2x, tangent at a=1 has slope 2.
    source: 'x^2',
    a: 1,
    domain: [-4, 4],
  },
  {
    id: 'sine',
    labelKey: 'preset.tangent.sine',
    // f(x) = sin(x), f′(x) = cos(x), tangent at a=π/3 has slope 0.5.
    source: 'sin(x)',
    a: Math.PI / 3,
    domain: [-2 * Math.PI, 2 * Math.PI],
  },
  {
    id: 'cubic',
    labelKey: 'preset.tangent.cubic',
    // f(x) = x³ − 3x, f′(x) = 3x² − 3, tangent at a=0.5 has slope 3(0.25)−3 = −2.25.
    source: 'x^3 - 3 * x',
    a: 0.5,
    domain: [-3, 3],
  },
  {
    id: 'exponential',
    labelKey: 'preset.tangent.exponential',
    // f(x) = exp(x), f′(x) = exp(x), tangent at a=0 has slope 1.
    source: 'exp(x)',
    a: 0,
    domain: [-3, 3],
  },
];
